import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { doPostPepRca, getPepRoleCountries, getPepRoles, getRcaRoles } from '../actions/pepRca';
import PepSection from '../components/pep/pep-section';
export default connect(state => ({
  submitted: state.pepRca.doPostPepRca.submitted,
  countries: state.pepRca.fetch.countries,
  pepRoles: state.pepRca.fetchPepRoles.pepRoles,
  rcaRoles: state.pepRca.fetchRcaRoles.rcaRoles,
  fetchingPepRolesState: state.pepRca.fetchPepRoles.fetchingState,
  fetchingRcaRolesState: state.pepRca.fetchRcaRoles.fetchingState,
  error: state.pepRca.doPostPepRca.error
}), dispatch => bindActionCreators({
  doPostPepRca,
  getPepRoleCountries,
  getPepRoles,
  getRcaRoles
}, dispatch))(PepSection);